var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"slideout-container",class:{ open : _vm.open},on:{"click":function($event){_vm.$emit('close')}}},[_c('div',{staticClass:"slideout",on:{"click":function($event){$event.stopPropagation();}}},[_vm._t("content")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }